import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ConcreteHierarchyItemInterface} from "../../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {Subscription} from "rxjs";
declare const Yiit;

@Component({
  selector: 'app-internal-floors-component',
  templateUrl: './internal-floors-component.component.html',
  styleUrls: ['./internal-floors-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InternalFloorsComponentComponent implements OnInit, OnDestroy {

  constructor(private concreteService: ConcreteLayerService, private uiAdapterService: UiAdapterService, private cd: ChangeDetectorRef) { }

  // public hasChildren = false;
  public list:ConcreteHierarchyItemInterface[] = [];
  public Yiit = Yiit;
  private subscriptions:Subscription;

  @Input() item:ConcreteHierarchyItemInterface;

  ngOnInit() {
    this.subscriptions = new Subscription();
    this.subscriptions.add(this.item.getChildren().subscribe((list)=>{
      this.list = list;
      // this.hasChildren = (list && list.length > 0);
    }))
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.cd.detach();
  }

  public selectConcreteLayer(concrete: ConcreteHierarchyItemInterface) {
    concrete.onSelect();
    this.uiAdapterService.selectedItem$ = concrete;
    this.cd.detectChanges();
  }

  public addConcreteLayer() {
    this.concreteService.drawConcreteLayer(null, (concrete: ConcreteLayer, error?) => {
      if (!error) {
        concrete.onSelect();
        this.uiAdapterService.selectedItem$ = concrete;
      } else {
        alert(error);
      }
    });
  }

}
